import type { ModelSpec } from '../shapes';

const modules = import.meta.glob<Record<string, unknown>>('./*.ts', { eager: true });

export const MODEL_SPECS: ModelSpec[] = Object.entries(modules)
  .filter(([path]) => !path.endsWith('/index.ts'))
  .flatMap(([, mod]) => Object.values(mod))
  .filter((v): v is ModelSpec[] => Array.isArray(v))
  .flat()
  .filter((m) => m && typeof m.id === 'string' && Array.isArray(m.shapes));
